import React from 'react'
import { Route, useRouteMatch } from 'react-router'

import QueueStateProvider from '../../providers/QueueStateProvider'
import ChatEditStateProvider from '../../providers/ChatEditStateProvider'
import AddRemoveParticipantProvider from '../../providers/AddRemoveParticipantProvider'
import OwnerProvider from '../../providers/OwnerProvider'
import VerificationProvider from '../../providers/VerificationProvider'
import MetaProvider from '../../providers/MetaProvider'
import EditProvider from '../../providers/EditProvider'
import CustomerProvider from '../../providers/CustomerProvider'

import Timeline from '../../pages/Timeline'

const TimelineRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Route
      path={path}
      render={() => (
        <QueueStateProvider>
          <ChatEditStateProvider>
            <AddRemoveParticipantProvider>
              <OwnerProvider>
                <VerificationProvider>
                  <MetaProvider>
                    <EditProvider>
                      <CustomerProvider>
                        <Timeline />
                      </CustomerProvider>
                    </EditProvider>
                  </MetaProvider>
                </VerificationProvider>
              </OwnerProvider>
            </AddRemoveParticipantProvider>
          </ChatEditStateProvider>
        </QueueStateProvider>
      )}
    />
  )
}

export default TimelineRoute
